import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reports--text-segment-form"
//
// Shows each input only for the aggregations that read it. Without this the
// modal offers a maximum on a Count, which saves and is then ignored.
//
// Both lists come from the model, so the form cannot disagree with what the
// accumulator applies.
export default class extends Controller {
  static targets = ["aggregation", "valueOrder", "maxValues"]

  static values = {
    valueOrderAggregations: Array,
    maxValuesAggregations: Array
  }

  // The modal opens on whatever the segment is already saved as, so the first
  // refresh happens here.
  connect() {
    this.refresh();
  }

  refresh() {
    const aggregation = this.aggregationTarget.value;

    this.#toggle(
      this.valueOrderTarget,
      this.valueOrderAggregationsValue.includes(aggregation)
    );
    this.#toggle(
      this.maxValuesTarget,
      this.maxValuesAggregationsValue.includes(aggregation)
    );
  }

  // The inputs keep submitting while hidden. The aggregations that hide them
  // ignore their columns, so a stale value is harmless. Switching back then
  // restores what was set rather than clearing it.
  #toggle(group, applies) {
    group.classList.toggle("d-none", !applies);
  }
}
